/** @format */

export const EditLarge = ({color}) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M23.7884 14.3118L12.8454 25.251L11.2547 23.6601L11.4189 23.4959H9.25564C8.84269 23.4959 8.50483 23.158 8.50483 22.745V20.5815L8.34106 20.7458C8.1191 20.9711 7.95627 21.2432 7.86758 21.5436L6.78924 25.2135L10.4569 24.1341C10.715 24.0449 11.0294 23.8807 11.2547 23.6601L12.8454 25.251C12.3574 25.7391 11.7521 26.1005 11.0904 26.2929L5.44388 27.9542C5.04877 28.0715 4.62128 27.9636 4.32988 27.6304C4.03846 27.3816 3.92951 26.9546 4.04579 26.5557L5.70667 20.91C5.90188 20.2483 6.25992 19.643 6.74841 19.1549L17.6881 8.21279L23.7884 14.3118ZM27.1201 6.73029C28.2933 7.90306 28.2933 9.80652 27.1201 10.9798L24.849 13.2511L18.7487 7.15125L21.0198 4.87986C22.193 3.70671 24.0981 3.70671 25.2713 4.87986L27.1201 6.73029Z"
                fill={color}
            />
        </svg>
    );
};
